import { Theme } from 'ui_system/theme';

const getLightnessFromHexColor = (hex) => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);

  let r = parseInt(result[1], 16);
  let g = parseInt(result[2], 16);
  let b = parseInt(result[3], 16);

  ((r /= 255), (g /= 255), (b /= 255));
  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);

  const lightness = (max + min) / 2;

  return lightness;
};

// Calculate if color should be white or black depending on the background color the user selected
export const setContrastColor = (hex) => {
  const lightness = getLightnessFromHexColor(hex);
  return lightness > 0.7 ? Theme.colors.black : 'white';
};
